import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const urlPrefix = "/plugins/org.graylog.plugins.datatiering/datatiering/repositories";
const translate = (key) => i18n.t(key, { ns: "enterprise_data_tiering" });
const DATA_TEARING_READINESS_KEY = "data_tiering_ready";
const getReadiness = () => fetch("GET", qualifyUrl(`${urlPrefix}/readiness`));
const useDataTiering = (enabled = true) => {
  const { data, isLoading } = useQuery({
    queryKey: [DATA_TEARING_READINESS_KEY],
    enabled,
    queryFn: () => defaultOnError(
      getReadiness(),
      translate("notifications.readiness_loading_failed"),
      translate("notifications.readiness_could_not_fetch")
    )
  });
  return {
    readiness: {
      data,
      isLoading
    }
  };
};
export default useDataTiering;
